<template>
    <div
        class="transition-colors"
        :class="[isSolidColorNav || !isOverlayNav ? 'bg-white shadow-md' : 'bg-transparent']">
        <div
            class="container flex flex-1 items-center justify-center gap-4 py-4 text-xs font-bold md:text-base lg:gap-12"
            :class="[
                isSolidColorNav || !isOverlayNav ? 'text-marineBlue' : 'text-primary-foreground',
            ]">
            <a href="/" class="mr-auto">
                <slot name="brand"></slot>
            </a>
            <slot name="desktop-links"></slot>

            <slot name="search"></slot>

            <slot name="login"></slot>
            <div class="lg:hidden">
                <slot name="mobile-trigger-icon" :openNav="() => (isMobileNavOpen = true)"></slot>
            </div>
            <MobileMainNavigation v-model:open="isMobileNavOpen">
                <template #menu-brand>
                    <slot name="mobile-brand"></slot>
                </template>
                <template #menu-links>
                    <slot name="mobile-links"></slot>
                </template>
            </MobileMainNavigation>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useNavContext } from '../composables'
import { MobileMainNavigation } from '.'

const isMobileNavOpen = ref(false)

const { isSolidColorNav, isOverlayNav } = useNavContext()
</script>

<style scoped></style>
